<template>
    <div class="continer">
        <background/>
        <div v-if="!isStartMake">
            <pageHeader :isCustom ="isLoading"/>
            <div v-if="isLoading" class="loading-info"><div class="loader"></div>信息提取中，请稍后</div>
            <div v-else>
                <div class="main">
                    <div class="back-btn" @click="backPage"><i class="el-icon-back"></i>返回上一步</div>
                    <div class="info">
                        <div class="date">
                            <div>
                                <span>记账日期：</span>
                                <el-date-picker
                                    v-model="date"
                                    :clearable="false"
                                    type="date"
                                    placeholder="选择日期"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="pickerOptions">
                                </el-date-picker>
                            </div>
                            <div class="add-btn" @click="addCause">添加一组事项</div>
                        </div>
                        <div v-if="isShowPageTips" class="tips"><img src="@/assets/images/busImage/warning.png"/>{{errorInfo.info}}</div>
                        <div class="cause" v-for="(item,index) in causeList" :key="index">
                            <div class="cause-input">
                                <div class="cause-input-label">事由</div>
                                <el-input
                                    type="textarea"
                                    autosize
                                    placeholder="请输入内容"
                                    v-model="item.cause">
                                </el-input>
                            </div>
                            <div class="other-info">
                                <div class="other-info-input">
                                    <span>金额：</span>
                                    <el-input v-model="item.amount"
                                            @input="(val) => {handleInput(val,index)}"
                                            @focus="(e)=> {focusInput(e,index)}" 
                                            @blur="(e)=> {blurInput(e,index)}"
                                            placeholder="请输入内容"></el-input>
                                </div>
                                <div class="other-info-input">
                                    <span>收支方式：</span>
                                        <el-radio-group v-model="item.payWay" text-color="#F7636E" fill="#FFEEF1">
                                            <el-radio-button
                                                v-for="(payItem,index) in payWayList"
                                                :key="index"
                                                :label="payItem.value" border>
                                                {{payItem.label}}
                                            </el-radio-button>
                                        </el-radio-group>
                                    
                                </div>
                                <div class="other-info-input">
                                    <span>银行名称：</span>
                                    <el-select v-model="item.bankId" 
                                            :popper-append-to-body="false" 
                                            popper-class="option-item"
                                            placeholder="请选择"
                                            clearable
                                            @change="(val) => {changeBank(val,index)}">
                                        <el-option
                                            v-for="item in bankList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div v-if="causeList.length > 1" class="del-icon" @click="delCause(index)">
                                <i class="el-icon-delete"></i>
                            </div>
                        </div>
                        <div class="image-block">
                            <div class="image-block-title">原始单据（张）：{{imageList.length}}</div>
                            <div class="image-list">
                                <div class="image-item" v-for="(item,index) in showImageList" :key="index" @click="previewImage(index)">
                                    <el-image
                                        style="width: 100%; height: 100%"
                                        :src="item.url"
                                        fit="contain">
                                    </el-image>
                                </div>
                                <div v-if="isShowMoreBtn" class="image-more" @click="showMore(7)">更多 <i class="el-icon-d-arrow-right"></i></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-btn" @click="makeOrder">确认制单</div>
            </div>
            
        </div>
        <div v-else>
            <pageHeader :isCustom="result.status" />
            <div class="main">
                <div v-if="isLoading" class="loading-info"><div class="loader"></div>制单中，请稍后</div>
                <div v-else class="result">
                    <div v-if="result.status">
                        <div class="result-info">
                            <img src="@/assets/images/busImage/confirm.png">
                            <span>制单成功</span>
                        </div>
                        <div class="tips">即将进入凭证分隔页打印页面，请勿离开</div>
                        <div class="tips"><span>{{result.countDownNum}}s</span>后自动进入打印页面</div>
                    </div>
                    <div v-else>
                        <div class="result-info-error">
                            <img src="@/assets/images/busImage/fail.png">
                            <span>制单失败</span>
                        </div>
                        <div class="tips">{{result.errorMessage}}</div>
                    </div>
                </div>
            </div>
        </div>
        <tipsDialog :dialogVisible="tipsDialogVisible" :tipsMessage="errorInfo.info">
            <div class="text-btn" @click="handleTipsBtn">{{errorInfo.isConfirmBtn ? '确定' : '我知道了'}}</div>
        </tipsDialog>
        <previewDialog ref="previewDialog" :isDelBtn="false"></previewDialog>
    </div>
</template>
<script>
import background from '@/components/background'
import pageHeader from '@/components/pageHeader'
import tipsDialog from '@/components/tipsDialog'
import previewDialog from '@/components/previewDialog'
import { cloneDeep,debounce } from 'lodash'
import { getAccountInfo,getBankList,saveInfo,getSaveStatus} from '@/api/order'
import { getCookie } from "@/utils/auth";
const causeInfo = {
    amount: '',
    bankId: '',
    bankName: '',
    cause: '',
    payWay: ''  
}
export default {
    components: { background,pageHeader,tipsDialog,previewDialog },
    data(){
        return {
            date: '',
            causeList: [],
            payWayList: [
                {
                    label: '现金',
                    value: 1
                },
                {
                    label: '银行存款',
                    value: 2
                },
                {
                    label: '无',
                    value: 0
                }
            ],
            fileIds:[],
            bankList: [],
            imageList: [],
            showImageList: [],
            isShowMoreBtn: false,
            isShowPageTips: false,
            tipsDialogVisible: false,
            errorInfo: {
                info: '',
                isConfirmBtn: false
            },
            isStartMake: false,
            isLoading: false,
            result: {
                status: true,
                countDownNum: 2,
                errorMessage: ''
            },
            separationType: '' // 收支类型
        }   
    },
    computed: {
        orgId() {
            if(getCookie('orgInfo')){
                return +(JSON.parse(getCookie('orgInfo')).id)
            }else {
                return 0
            }
        },
        booksId(){
            return getCookie('booksId')
        },
        pickerOptions(){
            let that = this
            return {
                disabledDate(time){
                    if(that.date){
                        let info = that.date.split('-')
                        let {firstDay,lastDay} = that.getFirstAndLastDayOfMonth(info[0],info[1])
                        return time.getTime() < new Date(firstDay).getTime() && time.getTime() > new Date(lastDay).getTime()
                    }else{
                        return false
                    }
                }
            }
        }
    },
    mounted(){
        this.getInfo()
        this.getBankInfo() 
        this.causeList.push(cloneDeep(causeInfo))
    },
    methods: {
        backPage(){
            this.$router.go(-1)
        },
        // 获取记账信息
        getInfo(){
            if(! this.orgId) return this.$message.error('数据异常')
            this.isLoading = true
            getAccountInfo({orgId:this.orgId}).then(res => {
                if(res.code === 200){
                    // 接口未返回，轮询请求
                    if(res.data.status === 2){
                        let timer = setTimeout(() => {
                            this.getInfo()
                            clearTimeout(timer)
                        },2000)
                    }else if(res.data.status === 0){
                        this.isLoading = false
                        // 错误信息
                        this.errorInfo.info = res.data.errorInfo
                        this.errorInfo.isConfirmBtn = true
                        this.errorInfo.isBack = true
                        this.tipsDialogVisible = true
                    }else {
                        this.isLoading = false
                        if (res.data.status === 4){
                            // 提示弹窗
                            this.errorInfo.info = res.data.errorInfo
                            this.errorInfo.isConfirmBtn = false
                            this.errorInfo.isBack = false
                            this.tipsDialogVisible = true
                        }
                        if(res.data.status === 3){ 
                            // 页面提示
                            this.isShowPageTips = true
                            this.errorInfo.info = res.data.errorInfo
                        }
                        this.handlePageInfo(res.data.accountingInformation,res.data.separationType)
                    }
                }
            }).catch(() => {
                this.isLoading = false
            })
        },
        getFirstAndLastDayOfMonth(year, month) {
            // 月份是从0开始的，所以需要减1
            const date = new Date(year, month - 1, 1)
            // 获取该月的第一天
            const firstDay = new Date(date)
            // 获取该月的最后一天
            const lastDay = new Date(year, month, 0)
            return {
                firstDay: firstDay,
                lastDay: lastDay
            }
        },
        handlePageInfo(info,separationType){
            this.date = info.date
            this.fileIds = info.fileIds
            this.causeList = info.accountingInformationItems.map(item => {
                item.amount = this.formateMoney(item.amount)
                return item
            })
            this.separationType = separationType || ''
            this.getShowImage(info.fileIds)
        },  
        // 获取银行信息
        getBankInfo(){
            getBankList({booksId: this.booksId,orgId: this.orgId}).then(res => {
                if(res.code === 200){
                    this.bankList = res.data || []
                }
            })
        },
        // 更换银行
        changeBank(val,index){
            for(let i = 0;i <this.bankList.length;i++){
                if(val === this.bankList[i].id){
                    this.causeList[index].bankName = this.bankList[i].name
                    return
                }
            }
        },
        handleInput(value,index) {
            const regex = /^\d+(\.\d*)?$/; // 使用正则表达式匹配 正整数 或小数点位数不限制的浮点数
            // 如果输入值不符合正则表达式，则将其设置为上一个有效值
            if(!regex.test(value)) {
                let money = value.toString().substring(0, value.toString().length - 1);
                this.$set(this.causeList[index], 'amount', money)
            }
        },
        /** 输入框获得焦点 */
        focusInput(e,index) {
            const val = e.target.value;
            this.$set(this.causeList[index], 'amount', this.moneyToNumber(val)) // 千分位转数值
        },
        /** 输入框失去焦点 */
        blurInput(e,index) {
            let val = e.target.value;
            val = val && isNaN(Number(val)) ? '' : val;
            this.$set(this.causeList[index], 'amount', this.formateMoney(val)) // 数值转为千分位格式
        },
        moneyToNumber(val){
            if(!val) val = ''
            return val.replace(/,/g, '')
        },
        formateMoney(num){
            if (num) {
                if (isNaN(num)) {
                    this.$message.error('金额中含有不能识别的字符')
                    return
                }
                num = typeof num == 'string' ? parseFloat(num) : num //判断是否是字符串如果是字符串转成数字
                num = num.toFixed(2) //保留两位
                num = parseFloat(num) //转成数字
                num = num.toLocaleString() //转成金额显示模式
                //判断是否有小数
                if (num.indexOf('.') == -1) {
                    num = num + '.00'
                } else {
                    num = num.split('.')[1].length < 2 ? num + '0' : num
                }
                return num //返回的是具有千分位格式并保留2位小数的字符串
            } else {
                return (num = null)
            }
        },
        getShowImage(fileIds){
            let imageInfo = JSON.parse(localStorage.getItem('imgShowList'))
            imageInfo = imageInfo.map(group => {
                group = group.filter(item => fileIds.includes(+item.fileId))
                return group
            })
            localStorage.setItem('imgShowList',JSON.stringify(imageInfo))
            let imageList = imageInfo.flat(1)
            if(imageList){
                this.imageList = JSON.parse(JSON.stringify(imageList))
                if(this.imageList.length > 8){
                    this.showImageList = imageList.splice(0,7)
                    this.isShowMoreBtn = true
                }else {
                    this.showImageList = imageList
                }
            }
        },
        showMore(index){
            this.showImageList = JSON.parse(JSON.stringify(this.imageList))
            this.isShowMoreBtn = false
        },
        // 预览图片
        previewImage(index){
            this.$refs.previewDialog.openDialog(this.imageList, index)
        },
        addCause(){
           this.causeList.push(cloneDeep(causeInfo)) 
        },
        delCause(index){
            this.causeList.splice(index,1)
        },
        handleTipsBtn(){
            if(this.errorInfo.isBack){
                this.$router.go(-1)
            }else {
                this.tipsDialogVisible = false
            }
        },
        // 必填较验
        checkRequire(info){
            let key = {
                payWay: '收支方式',
                amount: '金额',
                cause: '事由',
            }
            let validInfo = {
                valid: true
            }
            Object.keys(key).forEach(item => {
                if(info[item] === '' || info[item] === null || info[item] === undefined) {
                    validInfo.valid = false
                    validInfo.errKey = key[item]
                }
            })
            if(info.payWay === 2 && (!info.bankId || !info.bankName)){
                validInfo.valid = false
                validInfo.errKey = '银行'
            }
            return validInfo
        },
        // 校验
        validate(){
            let payList = JSON.parse(JSON.stringify(this.causeList))
            let stauts = true
            let errorIndex = 0
            let errKey = ''
            for(let i =0; i< payList.length;i++){
                let validInfo = this.checkRequire(payList[i])
                if(!validInfo.valid){
                    stauts = false
                    errorIndex = i,
                    errKey = validInfo.errKey
                    break
                }
            }
            if(!stauts){
                this.errorInfo.info = payList.length > 1 ? `事项${errorIndex+1}中${errKey}不能为空,请填写完整`: `${errKey}不能为空,请填写完整`
                this.errorInfo.isConfirmBtn = true
                this.errorInfo.isBack = false
                this.tipsDialogVisible = true
                return false
            }
            return true
        },
        makeOrder:debounce(function(){
            if(this.validate()){
                let payList = JSON.parse(JSON.stringify(this.causeList))
                let data = {
                    orgId: this.orgId,
                    booksId: this.booksId,
                    date: this.date,
                    accountingInformationItems: payList,
                    fileIds: this.fileIds,
                    separationType: this.separationType || ''
                }
                this.isStartMake = true
                this.isLoading = true
                saveInfo(data).then(res => {
                    if(res.code === 200){
                        this.getTaskInfo()
                    }else {
                        this.isLoading = false
                        this.result.status = false
                    }
                }).catch(() => {
                    this.isLoading = false
                    this.result.status = false
                })
            }
        }),
        // 获取保存结果
        getTaskInfo(){
            getSaveStatus().then(res => {
                if(res.code  === 200){
                    if(res.data.status === 0) {
                        // 制单失败
                        this.isLoading = false
                        this.result.status = false
                        this.result.errorMessage = res.data.errorMessage || ''
                    }else if(res.data.status === 2){
                        // 处理中循环调用
                        let timer = setTimeout(() => {
                            clearTimeout(timer)
                            this.getTaskInfo()
                        },2000)
                    }else  {
                        this.isLoading = false
                        this.result.status = true
                        this.result.id = res.data.id
                        this.handleCountDown()
                    }
                }
            })
        },
        handleCountDown(){
            let seconds = 2;
            let remainingSeconds = seconds;
            this.tipsMessage = remainingSeconds
            this.dialogVisible = true
            let that =  this
            this.timerId = setInterval(function() {
                if (remainingSeconds === 0) {
                    clearInterval(that.timerId);
                    that.$router.push({
                        name: 'printVouche',
                        query: {
                            id: that.result.id
                        }
                    })
                } else {
                    that.result.countDownNum = remainingSeconds
                    remainingSeconds--;
                }
            }, 1000);
        }

    }
}
</script>
<style lang="less" scoped>
    .continer {
        height: 100%;
        width: 100%;
        overflow: hidden;
    }
    .main {
        position: absolute;
        left: 30px;
        height: calc(100% - 211px);
        width: calc(100% - 60px);
        overflow: scroll;
        background: #FFFFFF;
        box-shadow: 0px 0px 1px 0px #FFEEF1, 0px 1px 2px 0px #FFEEF1, 0px 2px 4px 0px #FFEEF1;
        border-radius: 12px;
        margin: 157px auto 54px auto;
        .back-btn {
            width: 223px;
            height: 59px;
            line-height: 59px;
            background: #FFEEF1;
            border-radius: 12px 8px 8px 0px;
            font-size: 24px;
            text-align: center;
            color: #F7636E;
        }
        .info {
            margin: 25px 120px 0 120px;
            .date {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-weight: 500;
                font-size: 18px;
                color: rgba(0,0,0,0.85);
                .add-btn {
                    padding: 12px 32px;
                    background: linear-gradient( 135deg, #C62D2F 0%, #B23B34 100%);
                    border-radius: 8px;
                    font-size: 24px;
                    color: #FFFFFF;
                }
            }
            .tips {
                width: 100%;
                height: 52px;
                line-height: 52px;
                box-sizing: border-box;
                padding-left: 20px;
                margin-top: 20px;
                background: #FFFBE6;
                border-radius: 8px;
                border: 1px solid #FFF1B8;
                font-size: 20px;
                color: #BF3231;
                img {
                    width: 21px;
                    height: 21px;
                    margin-bottom: -3px;
                    margin-right: 10px;
                }
            }
            .cause {
                position: relative;
                display: flex;
                margin: 24px 0;
                padding: 31px 24px 11px 24px;
                background: rgba(0,0,0,0.03);
                border-radius: 4px;
                font-size: 18px;
                color: #000;
                &-input {
                    width: 668px;
                    height: 200px;
                    background-color: #FFFFFF;
                    border-radius: 4px;
                    border: 2px solid #DCDCDC;
                    &-label {
                        padding: 15px 24px;
                        border-bottom: 1px solid #DCDCDC;
                    }
                }
                .other-info {
                    margin-left: 20px;
                    &-input {
                        margin-bottom: 20px;
                        display: flex;
                        align-items: center;
                        span {
                            flex-shrink: 0;
                            width: 120px;
                        }
                    }
                }
                .del-icon {
                    position: absolute;
                    top: 123px;
                    right: -20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 42px;
                    height: 42px;
                    border-radius: 50%;
                    background: linear-gradient( 135deg, #C62D2F 0%, #B23B34 100%);
                    box-shadow: 0px 2px 4px 0px #FFD6DC;
                    color: #FFFFFF;
                }
                .option-item .el-select-dropdown__item {
                    height: 67px !important;
                    line-height: 67px !important;
                    font-size: 24px !important;
                }
                /deep/ .el-radio-group {
                    width: 530px;
                    display: flex;
                    justify-content: space-between;
                }
                /deep/ .el-radio-button {
                    border-radius: 4px;
                    border: 2px solid #FFD6DC;
                }
                /deep/ .el-radio-button__inner {
                    height: 38px;
                    line-height: 15px;
                    width: 158px;
                    font-size: 20px;
                    text-align: center;
                    box-sizing: border-box;
                    border: none;
                    color: #F7636E;
                }
                /deep/ .el-radio-button__inner:hover {
                    color: #F7636E !important;
                }
                /deep/ .el-textarea {
                    height: 141px;
                }
                /deep/ .el-textarea__inner {
                    height: 100% !important;
                    border: none !important;
                    font-size: 18px;
                    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
                }
                /deep/ .el-select .el-input .el-select__caret {
                    font-size: 20px;
                }
            }
            .image-block {
                &-title {
                    font-weight: 500;
                    font-size: 18px;
                    color: rgba(0,0,0,0.85);
                }
                .image-list {
                    margin-top: 12px;
                    display: flex;
                    flex-wrap: wrap;
                    gap:8px;
                }
                .image-item {
                    width: 180px;
                    height: 180px;
                    background: rgba(0,0,0,0.04);
                    border-radius: 4px;
                }
                .image-more {
                    width: 180px;
                    height: 180px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: #FFEEF1;
                    border-radius: 4px;
                    font-weight: 400;
                    font-size: 12px;
                    color: #E5484D;
                }
            }
            /deep/ input {
                width: 530px;
                height: 60px;
                border-radius: 4px;
                border: 2px solid #DCDCDC;
                font-size: 18px;
            }
        }
    }
    .main::-webkit-scrollbar {
        width: 0;
    }
    .footer-btn {
        position: absolute;
        top: calc(100% - 142px);
        left: calc(50% - 334px);
        width: 668px;
        height: 80px;
        line-height: 80px;
        background: linear-gradient( 135deg, #C62D2F 0%, #B23B34 100%);
        border-radius: 8px;
        font-weight: 600;
        font-size: 28px;
        color: #FFFFFF;
        text-align: center
    }
    .loading-info {
        position: absolute;
        top:40%;
        left: 50%;
        transform: translate(-50%,-50%);
        font-size: 32px;
        display: flex;
        // justify-content: center;
        align-items: center;
        .loader {
                margin-right: 40px;
                --d:12px;
                width: 1px;
                height: 1px;
                border-radius: 50%;
                color: #B33B34;
                box-shadow: 
                    calc(1*var(--d))      calc(0*var(--d))     0 0,
                    calc(0.707*var(--d))  calc(0.707*var(--d)) 0 0.5px,
                    calc(0*var(--d))      calc(1*var(--d))     0 1px,
                    calc(-0.707*var(--d)) calc(0.707*var(--d)) 0 1.5px,
                    calc(-1*var(--d))     calc(0*var(--d))     0 2px,
                    calc(-0.707*var(--d)) calc(-0.707*var(--d))0 1.5px,
                    calc(0*var(--d))      calc(-1*var(--d))    0 3px;
                animation: l27 1s infinite steps(8);
                }
                @keyframes l27 {
                100% {transform: rotate(1turn)}
        }
    }
    .result {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%,-50%);
        text-align: center;
        &-info {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 32px;
            font-weight: bold;
            img {
                margin-top: 8px;
            }
        }
        &-info-error {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 32px;
            font-weight: bold;
            img {
                margin-right: 20px;
            }
        }
        .tips {
            font-size: 20px;
            margin-top: 30px;
            span {
                color: #B63933;
                margin-right: 10px;
            }
        }
    }
</style>


